import { graphql } from '~/gql';

export const MatterActivitiesDocument = graphql(`
  query MatterActivities($matterId: BigInt!) {
    matterActivities(matterId: $matterId) {
      id
      matterId
      eventType
      actorId
      occurredAt
    }
  }
`);
